<template>
  <div>
    <el-container v-if="$route.meta.layout && $route.meta.layout != 0" class="app-wrapper">
      <el-aside :width="asideWidth" class="app-aside">
        <app-sidebar :collapse="sidebarCollapse" />
      </el-aside>
      <el-container class="app-main-container">
        <el-header height="auto" class="app-header-wrap">
          <app-header
            :collapse="sidebarCollapse"
            @toggle-collapse="sidebarCollapse = !sidebarCollapse"
            @change-email="email.show = true"
          />
          <tags-view />
        </el-header>
        <el-main class="app-main">
          <content-box />
        </el-main>
      </el-container>
    </el-container>
    <router-view v-else />

    <baseModal
      width="930px"
      title="更换坐席邮箱"
      @sureFun="confirmEmail"
      @cancalFun="() => { email.show = false }"
      :dialogVisible="email.show"
      style="z-index: 9999999;"
    >
      <template #content="scope">
        <el-form class="mt20" ref="form" label-width="140px">
          <el-form-item label="坐席邮箱:">
            <el-input
              placeholder="请输入要更换的邮箱"
              v-model="email.post.email"
              type="text"
              style="width: 760px;"
            ></el-input>
          </el-form-item>
        </el-form>
      </template>
    </baseModal>

    <Container />
  </div>
</template>

<script>
import baseModal from '@/components/common/baseModal.vue'
import Container from './Container.vue'
import AppSidebar from './components/AppSidebar/index.vue'
import AppHeader from './components/AppHeader.vue'
import TagsView from './components/TagsView/index.vue'
import contentBox from './components/content-box'
import { eltips } from '@/util/util.js'

export default {
  name: 'layout',
  components: {
    AppSidebar,
    AppHeader,
    TagsView,
    contentBox,
    Container,
    baseModal,
  },
  data() {
    return {
      sidebarCollapse: false,
      email: {
        show: false,
        post: { email: '' },
      },
    }
  },
  computed: {
    asideWidth() {
      return this.sidebarCollapse ? '64px' : '220px'
    },
  },
  methods: {
    confirmEmail() {
      this.axios.post('/api/house/admin/admin/change-email', this.email.post).then((res) => {
        if (res.code == 200) {
          eltips(res.msg, 'success')
        } else {
          eltips(res.msg, 'error')
        }
        this.email.show = false
      })
    },
  },
}
</script>

<style lang="less" scoped>
.app-wrapper {
  height: 100vh;
  width: 100%;
}
.app-aside {
  transition: width 0.2s;
  overflow: hidden;
  background: #304156;
}
.app-main-container {
  min-width: 0;
  background: #f0f2f5;
}
.app-header-wrap {
  padding: 0;
}
.app-main {
  padding: 0;
  overflow: hidden;
  height: calc(100vh - 84px);
}
</style>
